<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Corporate Details"
  [nzFooter]="null"
  [nzWidth]="900"
  (nzOnCancel)="modal.destroy()"
>
  <div class="details-modal-body" *nzModalContent>
    <div class="sidebar">
      <div class="flex-col-12">
        <nz-avatar nzSrc="assets/icons/corporate.svg"></nz-avatar>
        <div>
          <div class="name-line">
            {{ bodycorp.companyDetails?.name || '-' }}
          </div>
          <div class="email-line">
            BIN {{ bodycorp.companyDetails?.registrationNumber || '-' }}
          </div>
        </div>
      </div>

      <nz-divider class="divider-tight"/>

      <div>
        <p class="email-line">Roles</p>
        <div class="roles-wrap">
          <div class="role-item">
            <span class="role-badge" *ngIf="isPayer">
              {{ 'Payer' }}
            </span>
            <span class="role-badge" *ngIf="isRecipient">
              {{ 'Recipient' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="details-content">
      <nz-tabset>
        <nz-tab nzTitle="General">
          <div class="sections-wrap">
            <!-- Company Details -->
            <div>
              <div class="section-title">Company Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Company name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.name || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Registration Number / BIN</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.registrationNumber || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Details -->
            <div class="mb-2" *ngIf="bodycorp.contactPerson">
              <div class="section-title">Contact Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Email</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.contactPerson?.email || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Details -->
            <div *ngIf="bodycorp.address" class="mb-2">
              <div class="section-title">Address Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Country of main residence</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.country?.name || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Postal code</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.postalCode }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>City</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.city }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Street</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.street }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Building number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.buildingNumber }}</span>
                  </div>
                </div>

                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Office/Room number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address.officeRoomNumber }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Documents">
          <div class="document-list">
            <div *ngIf="certificate">
              <div class="document-group-title">
                <span>Certificate of Incorporation:</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(certificate)">{{ certificate.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ certificate.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</nz-modal>
